/* Centralized broker links.
All broker buttons import from here. */
export const BROKER_LINKS: Record<string,string> = {
  'IC Markets': /* @replace:broker-icmarkets */ 'https://www.icmarkets.com/global/en/open-trading-account/live/?camp=6849',
  'FxPro': /* @replace:broker-exness */ 'https://direct-vn.pro/vi/partner/11378220',
  'XM': /* @replace:broker-xmtrading */ 'https://clicks.pipaffiliates.com/c?c=1311997&l=vi&p=1',
};
